import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { AUTOMATIC_COUPON_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateAutomaticCouponSettingAction = createAsyncThunk(
    'coupon/updateAutomaticCouponSettingAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(`${ AUTOMATIC_COUPON_SETTINGS_PATH }/${ data.automaticCouponType }`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateAutomaticCouponSettingSlice = createSlice({
    name: 'updateAutomaticCouponSettingSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateAutomaticCouponSettingAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateAutomaticCouponSettingAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateAutomaticCouponSettingAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateAutomaticCouponSettingState = (state) => state.coupon.updateAutomaticCouponSetting;
export default updateAutomaticCouponSettingSlice.reducer;
